import { render, staticRenderFns } from "./HubblePlotXAxisScaleControl.vue?vue&type=template&id=7cbf6982&scoped=true"
import script from "./HubblePlotXAxisScaleControl.vue?vue&type=script&lang=ts"
export * from "./HubblePlotXAxisScaleControl.vue?vue&type=script&lang=ts"
import style0 from "./HubblePlotXAxisScaleControl.vue?vue&type=style&index=0&id=7cbf6982&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbf6982",
  null
  
)

export default component.exports